import { getGlobalStore } from '@/lib/global-store';
const { getters, dispatch, } = getGlobalStore();
/**
 * 엄격한 권한 관리를 위한 권한 확인 메서드입니다.
 * v-ui-permission에 적용 될 필요는 없습니다.
 * 사용자 인터렉션 중 권한이 필요할 때 최신 값을 체크 할 수 있습니다.
 * @param permission 필요한 권한 목록
 * @param requiredLevel 권한이 있는 유저레벨 목록
 * @param isEvery 권한이 모두 필요한지
 * @returns 권한이 있는지 여부
 */
export const getRealTimePermission = async (permission, requiredLevel = [], isEvery = false) => {
    await dispatch('user/getUserInfo');
    dispatch('user/setUserPermission');
    // userLevel 검사
    const userLevel = getters['user/userLevel'];
    let isLevelPassed = true;
    if (requiredLevel.length !== 0) {
        isLevelPassed = requiredLevel.includes(userLevel);
    }
    // 권한 검사
    const getterUserPermission = getters['user/getterUserPermission'](permission, isEvery);
    const isPermitted = isLevelPassed && getterUserPermission;
    return isPermitted;
};
